// @flow
import * as Immutable from 'immutable'; // This is required
import ImmutableModel from './ImmutableModel';
import { LineItem } from './LineItem';
import type { LineItemModelType } from './LineItem';
import type { ChecklistModelType } from './TaskChecklists';

export type CratingInfoModelType = {
    crates: number
};

export type TransactionDetailModelType = {
    canTransactPartial: boolean,
    transactionDuration: number,
    checklist?: ?ChecklistModelType
};

export type OrderDetailModelType = {
    lineItems?: ?Array<LineItemModelType>,
    cratingInfo: ?CratingInfoModelType,
    transactionDetail: TransactionDetailModelType
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class OrderDetail extends ImmutableModel {
    static fromJS(json: OrderDetailModelType): OrderDetail {
        const state: Object = Object.assign({}, json);
        state.lineItems = state.lineItems
            ? Immutable.List(state.lineItems).map(item => LineItem.fromJS(item))
            : state.lineItems;
        state.cratingInfo = state.cratingInfo
            ? CratingInfo.fromJS(state.cratingInfo)
            : state.cratingInfo;
        state.transactionDetail = TransactionDetail.fromJS(
            state.transactionDetail
        );
        return new this(Immutable.Map(state));
    }

    toJS(): OrderDetailModelType {
        const js: OrderDetailModelType = {
            cratingInfo: this.cratingInfo
                ? this.cratingInfo.toJS()
                : this.cratingInfo,
            transactionDetail: this.transactionDetail.toJS()
        };

        if (this.lineItems != null) {
            js.lineItems = this.lineItems
                ? this.lineItems.toArray().map(item => item.toJS())
                : this.lineItems;
        }

        return js;
    }

    get lineItems(): ?Immutable.List<LineItem> {
        return this._state.get('lineItems');
    }

    setLineItems(lineItems: ?Immutable.List<LineItem>): this {
        return this.clone(this._state.set('lineItems', lineItems));
    }

    get cratingInfo(): ?CratingInfo {
        return this._state.get('cratingInfo');
    }

    setCratingInfo(cratingInfo: ?CratingInfo): this {
        return this.clone(this._state.set('cratingInfo', cratingInfo));
    }

    get transactionDetail(): TransactionDetail {
        return this._state.get('transactionDetail');
    }

    setTransactionDetail(transactionDetail: TransactionDetail): this {
        return this.clone(
            this._state.set('transactionDetail', transactionDetail)
        );
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class CratingInfo extends ImmutableModel {
    static fromJS(json: CratingInfoModelType): CratingInfo {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    toJS(): CratingInfoModelType {
        return {
            crates: this.crates
        };
    }

    get crates(): number {
        return this._state.get('crates');
    }

    setCrates(crates: number): this {
        return this.clone(this._state.set('crates', crates));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class TransactionDetail extends ImmutableModel {
    static fromJS(json: TransactionDetailModelType): TransactionDetail {
        const state: Object = Object.assign({}, json);
        state.checklist = state.checklist
            ? Checklist.fromJS(state.checklist)
            : state.checklist;
        return new this(Immutable.Map(state));
    }

    toJS(): TransactionDetailModelType {
        const js: TransactionDetailModelType = {
            canTransactPartial: this.canTransactPartial,
            transactionDuration: this.transactionDuration
        };

        if (this.checklist != null) {
            js.checklist = this.checklist
                ? this.checklist.toJS()
                : this.checklist;
        }

        return js;
    }

    get canTransactPartial(): boolean {
        return this._state.get('canTransactPartial');
    }

    setCanTransactPartial(canTransactPartial: boolean): this {
        return this.clone(
            this._state.set('canTransactPartial', canTransactPartial)
        );
    }

    get transactionDuration(): number {
        return this._state.get('transactionDuration');
    }

    setTransactionDuration(transactionDuration: number): this {
        return this.clone(
            this._state.set('transactionDuration', transactionDuration)
        );
    }

    get checklist(): ?Checklist {
        return this._state.get('checklist');
    }

    setChecklist(checklist: ?Checklist): this {
        return this.clone(this._state.set('checklist', checklist));
    }
}
